import { render } from "./BlogBuissonniere.vue?vue&type=template&id=8126e936"
import script from "./BlogBuissonniere.vue?vue&type=script&lang=js"
export * from "./BlogBuissonniere.vue?vue&type=script&lang=js"

import "./BlogBuissonniere.vue?vue&type=style&index=0&id=8126e936&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__